import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  BudgetItemSummary,
  BudgetMacroItem,
  CostCenterSummary,
  Identity,
  ProjectSubtaskSummary,
} from '@libs/core/api';
import {
  getValueOrError,
  updateFormTreeValueAndValidity,
} from '@front-end/core/utils';
import { NgxAuthService } from 'ngx-auth-utils';
import { first, Observable } from 'rxjs';

export interface FundCashPurchaseForm {
  budgetItem: FormControl<BudgetItemSummary | undefined | null>;
  notes: FormControl<string | null | undefined>;
  articleId: FormControl<number | null | undefined>;
  isRecurringRequested: FormControl<boolean | null | undefined>;
}

export interface FundCashPurchaseFormValues {
  budgetItem: BudgetItemSummary;
  notes: string | null | undefined;
  isRecurringRequested: boolean | null | undefined;
}

export function buildFundCashPurchaseForm(): FormGroup<FundCashPurchaseForm> {
  return new FormBuilder().group<FundCashPurchaseForm>({
    budgetItem: new FormControl<BudgetItemSummary | undefined>(undefined, {
      validators: [Validators.required],
    }),
    notes: new FormControl<string | null>(null),
    articleId: new FormControl<number | undefined>(undefined),
    isRecurringRequested: new FormControl<boolean>(false),
  });
}

@Component({
  selector: 'front-end-fund-cash-purchase-form',
  templateUrl: './fund-cash-purchase-form.component.html',
  styleUrls: ['./fund-cash-purchase-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashPurchaseFormComponent {
  @Input() id!: string;
  @Input() form!: FormGroup<FundCashPurchaseForm>;
  @Input() project!: CostCenterSummary;
  @Input() budgetProjectTasks: BudgetMacroItem[] = [];
  @Input() allowedSubtasks: ProjectSubtaskSummary[] = [];
  @Input() showRecurring = false;

  @Output() submitted = new EventEmitter<FundCashPurchaseFormValues>();

  readonly identity$: Observable<Identity> = this.authService.state.pipe(
    first()
  );

  constructor(private readonly authService: NgxAuthService) {}

  submit() {
    updateFormTreeValueAndValidity(this.form);
    if (this.form.valid) {
      this.submitted.emit({
        budgetItem: getValueOrError(this.form.value.budgetItem),
        notes: this.form.value.notes,
        isRecurringRequested: this.form.value.isRecurringRequested,
      });
    }
  }

  compareId(o1: { id: unknown }, o2: { id: unknown }) {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }
}
